
import {
    GrpcService,
    HttpRequestDelegate,
} from "../../../grpc"

import {
    Gender,
    Language,
} from "../../../sennotech/scanner/v2/type"

import {
    Timestamp,
} from "../../../google/protobuf/timestamp"

import {
    Empty,
} from "../../../google/protobuf/empty"

export interface Examinee {
    id: number /* 被检测者ID */
    nickname: string /* 昵称 */
    gender: Gender /* 性别 */
    mobileNumber?: string /* 联系方式 */
    birthTime: Timestamp /* 出生日期毫秒级时间戳 */
    height?: number /* 身高（cm） */
    weight?: number /* 体重（kg） */
    description?: string /* 描述信息/病征 */
    email?: string /* 邮箱 */
    partnerId?: string /* 第三方id，用于第三方系统回调 */
}

export interface CreateExamineeRequest {
    nickname: string /* 昵称 */
    gender: Gender /* 性别「必填」 */
    storeId?: number /* 创建被检测人的店铺ID */
    birthDate: Timestamp /* 出生日期毫秒级时间戳 */
    mobileNumber?: string /* 手机号 */
    height?: number /* 身高（cm） */
    weight?: number /* 体重（kg） */
    description?: string /* 描述信息/病征 */
    email?: string /* 邮箱 */
    partnerId?: string /* 第三方id，用于第三方系统回调 */
}

export interface GetExamineeRequest {
    id: number
}

export interface GetExamineeExcelTemplateRequest {
    language: Language
}

export interface GetExamineeExcelTemplateResponse {
    url: string
}

export interface ImportExamineesFromExcelRequest {
    url: string
    storeId: number
}

export interface UpdateExamineeRequest {
    examineeId: number /* 被检测者ID */
    gender: Gender /* 性别 */
    nickname?: string /* 昵称 */
    mobileNumber?: string /* 联系方式 */
    birthDate: Timestamp /* 出生日期毫秒级时间戳 */
    height?: number /* 身高（cm） */
    weight?: number /* 体重（kg） */
    description?: string /* 描述信息/病征 */
    email?: string /* 邮箱 */
}

export interface ListExamineesRequest {
    pageNum: number
    pageSize: number
    /*int64 account_id = 3; // 检测者ID */
    storeId?: number /* 店铺ID */
    nickname?: string /* 被检测者昵称 */
    mobileNumber?: string /* 手机号 */
}

export interface ListExamineesResponse {
    examinees: Array<Examinee>
    totalElements: number
    totalPages: number
    isFirst: boolean
    isLast: boolean
    pageElements: number
    pageNum: number
    pageSize: number
}

export interface GenerateExamineeQRCodeRequest {
    ticket: string /* 报告ticket */
    storeId: number /* 店铺ID */
}

export interface GenerateExamineeQRCodeResponse {
    url: string /* 二维码图片URL */
}

export interface GetThirdPartyExamineeApiInfoRequest {
    storeId: number /* 店铺ID */
}

export interface GetThirdPartyExamineeApiInfoResponse {
    method: string /* GET, POST */
    url: string /* 接口URL */
    parameter: string /* 接口参数 */
}

export class ExamineeService extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    /* 创建被检测者信息 */
    async createExaminee(request: CreateExamineeRequest): Promise<Examinee> {
        const method = "post"
        const path = "/scanner.v2.ExamineeService/CreateExaminee"
        return await this.call(method, path, request) as Examinee
    }
    
    /* 获取被检测者信息 */
    async getExaminee(request: GetExamineeRequest): Promise<Examinee> {
        const method = "post"
        const path = "/scanner.v2.ExamineeService/GetExaminee"
        return await this.call(method, path, request) as Examinee
    }
    
    /* 获取导入模板 */
    async getExamineeExcelTemplate(request: GetExamineeExcelTemplateRequest): Promise<GetExamineeExcelTemplateResponse> {
        const method = "post"
        const path = "/scanner.v2.ExamineeService/GetExamineeExcelTemplate"
        return await this.call(method, path, request) as GetExamineeExcelTemplateResponse
    }
    
    /* 通过表格导入用户 */
    async importExamineesFromExcel(request: ImportExamineesFromExcelRequest): Promise<Empty> {
        const method = "post"
        const path = "/scanner.v2.ExamineeService/ImportExamineesFromExcel"
        return await this.call(method, path, request) as Empty
    }
    
    /* 修改被检测者信息 */
    async updateExaminee(request: UpdateExamineeRequest): Promise<Examinee> {
        const method = "post"
        const path = "/scanner.v2.ExamineeService/UpdateExaminee"
        return await this.call(method, path, request) as Examinee
    }
    
    /* 获取被检测者列表 */
    async listExaminees(request: ListExamineesRequest): Promise<ListExamineesResponse> {
        const method = "post"
        const path = "/scanner.v2.ExamineeService/ListExaminees"
        return await this.call(method, path, request) as ListExamineesResponse
    }
    
    /* 生成被检测者信息填写 二维码 */
    async generateExamineeQRCode(request: GenerateExamineeQRCodeRequest): Promise<GenerateExamineeQRCodeResponse> {
        const method = "post"
        const path = "/scanner.v2.ExamineeService/GenerateExamineeQRCode"
        return await this.call(method, path, request) as GenerateExamineeQRCodeResponse
    }
    
    /* 获取第三方被检测者信息的接口信息 */
    async getThirdPartyExamineeApiInfo(request: GetThirdPartyExamineeApiInfoRequest): Promise<GetThirdPartyExamineeApiInfoResponse> {
        const method = "post"
        const path = "/scanner.v2.ExamineeService/GetThirdPartyExamineeApiInfo"
        return await this.call(method, path, request) as GetThirdPartyExamineeApiInfoResponse
    }
    
}
